/* ============================================
   ETHOS LABS — Advertorial Page JS
   ============================================ */

(function() {
  'use strict';

  /* --- Reveal safety net ---
     .el-reveal starts at opacity:0 and is only revealed by the observer below. The
     stylesheet keeps everything visible until this class is present, so that a JS
     failure leaves the page unanimated rather than blank. Added immediately, before
     anything that could throw, and as early as possible to avoid a visible flash. */
  function armReveal() {
    document.querySelectorAll('.el-adv').forEach(function (el) {
      el.classList.add('el-adv--js');
    });
  }
  try { armReveal(); } catch (e) { /* leave content visible */ }
  document.addEventListener('DOMContentLoaded', function () {
    try { armReveal(); } catch (e) {}
  });

  /* --- Reading Progress Bar --- */
  function initProgressBar() {
    const bar = document.querySelector('.el-adv__progress');
    if (!bar) return;

    window.addEventListener('scroll', function() {
      const docHeight = document.documentElement.scrollHeight - window.innerHeight;
      const scrolled = (window.scrollY / docHeight) * 100;
      bar.style.width = scrolled + '%';
    });
  }

  /* --- Scroll Reveals --- */
  function initScrollReveal() {
    const reveals = document.querySelectorAll('.el-adv .el-reveal');
    if (!reveals.length) return;

    const observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          entry.target.classList.add('el-reveal--visible');
          observer.unobserve(entry.target);
        }
      });
    }, {
      threshold: 0.1,
      rootMargin: '0px 0px -40px 0px'
    });

    reveals.forEach(el => observer.observe(el));
  }

  /* --- Parallax Hero Background --- */
  function initHeroParallax() {
    const heroBg = document.querySelector('.el-adv__hero');
    if (!heroBg || window.innerWidth < 750) return;

    let ticking = false;
    window.addEventListener('scroll', function() {
      if (!ticking) {
        requestAnimationFrame(function() {
          const scrolled = window.scrollY;
          heroBg.style.backgroundPositionY = (scrolled * 0.3) + 'px';
          ticking = false;
        });
        ticking = true;
      }
    });
  }

  /* --- Estimated Read Time (all text blocks combined) --- */
  function initReadTime() {
    const bodies = document.querySelectorAll('.el-adv__body');
    const readEl = document.querySelector('[data-read-time]');
    if (!bodies.length || !readEl) return;

    let totalWords = 0;
    bodies.forEach(function(b) {
      const text = b.textContent || '';
      totalWords += text.trim().split(/\s+/).length;
    });
    const minutes = Math.ceil(totalWords / 220);
    readEl.textContent = minutes + ' min read';
  }

  /* --- Sticky CTA Bar --- */
  function initStickyBar() {
    const sticky = document.getElementById('el-adv-sticky');
    if (!sticky) return;

    var visible = false;

    /* Show after scrolling past 30% of the page */
    window.addEventListener('scroll', function() {
      var scrollPercent = window.scrollY / (document.documentElement.scrollHeight - window.innerHeight);
      var shouldShow = scrollPercent > 0.25 && scrollPercent < 0.95;

      if (shouldShow && !visible) {
        sticky.classList.add('el-adv__sticky--visible');
        visible = true;
      } else if (!shouldShow && visible) {
        sticky.classList.remove('el-adv__sticky--visible');
        visible = false;
      }
    });
  }

  /* --- Init --- */
  function init() {
    initProgressBar();
    initScrollReveal();
    initHeroParallax();
    initReadTime();
    initStickyBar();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
